import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { EditorView } from '@atlaskit/editor-prosemirror/view';

import { registerEditorView } from '../editorViewRegistry';

import { editorViewPluginKey } from './types';

/**
 * Plugin used to provide access to the EditorView to the Code Suggestions Plugin
 */
export const registerEditorViewPlugin = () =>
  new SafePlugin({
    key: editorViewPluginKey,
    view(editorView: EditorView) {
      const editorViewId = editorView.dom.getAttribute('data-editor-id');
      if (editorViewId) {
        registerEditorView(editorViewId, editorView);
      }
      return {};
    },
  });
